export default {
    props: {
        expand: {
            type: Boolean,
            default: undefined,
            kComposite: 'expand'
        }, 
        name: {
            type: String,
            default: undefined,
            kComposite: 'name'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoPivotColumn/Columns.js